import { Box, Typography } from "@mui/material";
import { colors } from "../../Style";
import { useEffect } from "react";
import { DownArrow, UpArrow } from "../UI/Arrows";

const findActiveIndex = (value, values) => {
  return values.indexOf(value);
};
export const SelectInputMenu = (props) => {
  const navigation = (navigator, action, menu, state) => {
    if (action.type === "CLICK") {
      switch (menu[action.button].route) {
        case "NAVIGATE_CANCEL":
          cancelClicked(state);
          break;
        case "NAVIGATE_SAVE":
          saveClicked(state);
          break;
        case "VALUE_UP":
          valueUp(state);
          break;
        case "VALUE_DOWN":
          valueDown(state);
          break;
      }
    }
  };

  const updateNavigation = (windowState) => {
    let menu = {
			LEFT: { label: "Back", route: "NAVIGATE_CANCEL", local: true },
			RIGHT: { label: "Select", route: "NAVIGATE_SAVE", local: true },
      MIDDLE: { label: "Value" },
		};
    const showUpButton = windowState?.activeItemIndex > 0;
    const showDownButton = windowState?.activeItemIndex < windowState?.values.length - 1;

		menu.UP = showUpButton
			? { label: "UP", route: "VALUE_UP", local: true }
			: null;
		menu.DOWN = showDownButton
			? { label: "DOWN", route: "VALUE_DOWN", local: true }
			: null;
		return menu;
  };

  const startActiveItemIndex = findActiveIndex(props.value, props.values)
  const defaultState = {
    name: props.name,
    activeItemIndex: startActiveItemIndex,
    label: props.label,
    value: props.value,
    values: props.values,
    windowNavigation: navigation,
  };

  const menu = {
    LEFT: { label: "Cancel", route: "NAVIGATE_CANCEL", local: true },
    UP: startActiveItemIndex <= 0 ? null : { label: "UP", route: "VALUE_UP", local: true },
    RIGHT: { label: "Save", route: "NAVIGATE_SAVE", local: true },
    MIDDLE: { label: "Value" },
    DOWN: startActiveItemIndex >= props.values.length - 1 ? null : { label: "DOWN", route: "VALUE_DOWN", local: true },
  }

  defaultState.menu = menu;
  const windowState = props?.state
    ? {
        ...props.state,
        menu: menu,
      }
    : defaultState;


  const setWindowState = (windowState) => {
    props.setState(windowState.menu, windowState);
  };


  const cancelClicked = (state) => {
    props.onCancel(state);
  };

  const valueUp = (state) => {
    const prevIndex = state.activeItemIndex
    let newActiveIndex = prevIndex > 0 ? prevIndex - 1 : prevIndex;
		let newState = { ...state, activeItemIndex: newActiveIndex };
		setWindowState({
			...state,
			activeItemIndex: newActiveIndex,
			menu: updateNavigation(newState),
		});
  };

  const valueDown = (state) => {
    const prevIndex = state.activeItemIndex
    let newActiveIndex = prevIndex < state?.values?.length ? prevIndex + 1 : prevIndex;
		let newState = { ...state, activeItemIndex: newActiveIndex };
		setWindowState({
			...state,
			activeItemIndex: newActiveIndex,
			menu: updateNavigation(newState),
		});
  };

  const saveClicked = (state) => {
    props.onComplete(state.values[state.activeItemIndex])
  };

  useEffect(() => {
    if (true) {
      windowState.windowNavigation = navigation;
      props.setState(menu, windowState);
    }
  }, [windowState.name]);


  const arrowMargin = { left: "47%", top: "10px", bottom: "10px" };

  return (
    <Box
      sx={{
        width: "450px",
        height: "225px",
        background: "black",
        border: "1px solid white",
        p: 1,
      }}
    >
      <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <Typography variant="h6" sx={{color:colors().TEXT_COLOR, fontWeight: "bold" }}>
          {windowState?.label}
        </Typography>
      </Box>
      <Box
        sx={{ mt: 2, width: "100%", display: "absolute"}}
      >
          <Typography
					variant="h7"
					sx={{ color: colors().COLORS_SUBITEM_DEFAULT, fontWeight: "bold", marginLeft:"46%" }}
				  >
					  {windowState?.values[windowState.activeItemIndex - 1] != null ? props.format(windowState?.values[windowState.activeItemIndex - 1]) : ""}
				  </Typography>
          <Box  sx={{display: "absolute",  marginLeft: "10px" }}>          
          {
              windowState?.activeItemIndex - 1 < 0 ?              
              <></>
            :
              <UpArrow sx={{ marginLeft: arrowMargin.left, height: "20px", }} />
          }
          <Typography variant="h5" sx={{color:colors().TEXT_COLOR, fontWeight: "bold", marginLeft:"42%", height: "35px" }}>
            {props.format(windowState?.values[windowState?.activeItemIndex])}
          </Typography>
          {
            windowState.activeItemIndex + 1 > windowState.values.length - 1  ?
            <></>
          :
            <DownArrow sx={{ marginLeft: arrowMargin.left, height: "20px" }} />
          }
        </Box>
          <Typography
					variant="h7"
					sx={{color: colors().COLORS_SUBITEM_DEFAULT, fontWeight: "bold", marginLeft:"46%" }}
				  >
					  {windowState?.values[windowState.activeItemIndex + 1] != null ? props.format(windowState?.values[windowState.activeItemIndex + 1]) : ""}
				  </Typography>
      </Box>
    </Box>
  );
};
